<template>
  <div>
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title aling="center">Configuración: {{evdesc}}</v-toolbar-title>
      </v-toolbar>
    <v-card>
        <v-btn absolute dark top right color="success" @click="publicar" v-if="datosEv.estado == 0">
          <v-icon>mdi-gauge</v-icon> Publicar
        </v-btn>  
        <v-card-text>    
          <v-container>
              <v-row>
                <v-col cols="3">
                    Fecha Inicio: {{evfecini}}
                </v-col>
                <v-col cols="3">
                    Fecha Final: {{evfecfin}}
                </v-col>
                <v-col cols="3">
                    Competencias: {{evcompetencias}}%
                </v-col>
                <v-col cols="3">
                    Objetivos: {{evobjetivos}}%
                </v-col>                           
              </v-row>
          </v-container>
        </v-card-text>
    </v-card>
            <v-tabs>
                <v-tab align-with-title="true" @click="rep('com')">
                    <v-icon left>mdi-email</v-icon>
                    Avisos
                </v-tab>

                <v-tab style="align-content: flex-start;" v-if="datosNiv.length > 0">
                    <v-icon left>mdi-speedometer</v-icon>
                    Niveles de Evaluacion
                </v-tab>

                <v-tab align-with-title="true" v-if="vcompetencias > 0" @click="rep('com')">
                    <v-icon left>mdi-elevation-rise</v-icon>
                    Competencias ({{sumCom}}%)
                </v-tab>

                <v-tab style="align-content: flex-start;" v-if="vobjetivos > 0" @click="rep('obj')">
                    <v-icon left>mdi-code-equal</v-icon>
                    Objetivos ({{sumObj}}%)
                </v-tab>

                <v-tab style="align-content: flex-start;" v-if="datosEv.estado == 1">
                    <v-icon left>mdi-account-convert</v-icon>
                    Etapas Usuarios
                </v-tab>                

                <v-tab-item>
                  <v-card flat>
                    <v-card-text>
                      <v-row v-for="(avi) in avisos" :key="avi.id">
                        <v-col cols="6">
                          <avisoinicio :aviso="avi"/>
                        </v-col>
                        <v-col cols="6">
                          <avisofin :aviso="avi"/>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>

                <v-tab-item  v-if="datosNiv.length > 0">
                    <v-card flat>
                        <v-card-text>
                            <v-card flat>
                                <v-card-text>
                                  <v-row>
                                    <v-col cols="12"  v-for="niv in datosNiv" :key="niv.id">
                                      <v-text-field v-model="niv.concepto" :label="'Concepto del puntaje ' + niv.numero" outlined @blur="saveNiveles"></v-text-field>                        
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                            </v-card>
                        </v-card-text>
                    </v-card>
                </v-tab-item>

                <v-tab-item v-if="vcompetencias > 0">
                    <v-card flat>
                        <v-card-subtitle>
                         <v-btn absolute dark fab top right color="success" @click="dialog = true">
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>                      
                        </v-card-subtitle>
                        <v-card-text>
                            <v-card flat>
                                <v-card-text>
                                <v-data-table
                                    :headers="headers"
                                    :items="datosCom"
                                    :items-per-page="5"
                                    class="elevation-1"
                                    :search="search"
                                >
                                    <template v-slot:item.actions="{ item }" >
                                    <v-icon small @click="editItem(item)">mdi-pencil</v-icon>
                                    <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
                                    <!-- <v-icon small @click="asignacion(item)">mdi-vector-polygon</v-icon> -->
                                    </template>
                                </v-data-table>
                                </v-card-text>
                            </v-card>
                        </v-card-text>
                    </v-card>
                </v-tab-item>

                <v-tab-item v-if="vobjetivos > 0">
                    <v-card flat>
                        <v-card-subtitle>
                         <v-btn absolute dark fab top right color="success" @click="dialog = true">
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                        </v-card-subtitle>
                        <v-card-text>
                            <v-card flat>
                                <v-card-text>
                                <v-data-table
                                    :headers="headers"
                                    :items="datosObj"
                                    :items-per-page="5"
                                    class="elevation-1"
                                    :search="search"
                                >
                                    <template v-slot:item.actions="{ item }">
                                    <v-icon small @click="editItem(item)">mdi-pencil</v-icon>
                                    <v-icon small class="mr-2" @click="deleteItem(item)">mdi-delete</v-icon>
                                    <!-- <v-icon small @click="asignacion(item)">mdi-vector-polygon</v-icon> -->
                                    </template>
                                </v-data-table>
                                </v-card-text>
                            </v-card>
                        </v-card-text>
                    </v-card>
                </v-tab-item>

               <v-tab-item>
                    <v-card flat>
                        <v-card-text>
                          <!-- <v-autocomplete v-model="movimientos" :items="colaboradores" 
                          outlined label="Colaboradores" item-text="nombres" item-value="id" multiple
                        >
                          <template v-slot:selection="data">
                            <v-chip
                              v-bind="data.attrs"
                              :input-value="data.selected"
                              close
                              @click="data.select"
                              @click:close="remove(data.item)"
                            >
                              <v-avatar left>
                                <v-img :src="data.item.imagen_usuario"></v-img>
                              </v-avatar>
                              {{ data.item.nombres }}
                            </v-chip>
                          </template>
                          <template v-slot:item="data">
                            <template v-if="typeof data.item !== 'object'">
                              <v-list-item-content v-text="data.item"></v-list-item-content>
                            </template>
                            <template v-else>
                              <v-list-item-avatar>
                                <img :src="data.item.imagen_usuario">
                              </v-list-item-avatar>
                              <v-list-item-content>
                                <v-list-item-title v-html="data.item.nombres"></v-list-item-title>
                                <v-list-item-subtitle v-html="data.item.grupo"></v-list-item-subtitle>
                              </v-list-item-content>
                            </template>
                          </template>
                        </v-autocomplete> -->
                          <v-autocomplete v-model="movimientos" :items="colaboradores2" 
                          outlined label="Colaboradores" item-text="nombres" item-value="iden" multiple>
                          <template v-slot:selection="data">
                            <v-chip
                              v-bind="data.attrs"
                              :input-value="data.selected"
                              close
                              @click="data.select"
                              @click:close="removeGrup(data.item)"
                            >
                              <v-avatar left>
                                <v-img :src="data.item.imagen_usuario"></v-img>
                              </v-avatar>
                              {{ data.item.nombres }}
                            </v-chip>
                          </template>
                          <template v-slot:item="data">
                            <template v-if="typeof data.item !== 'object'">
                              <v-list-item-content v-text="data.item"></v-list-item-content>
                            </template>
                            <template v-else>
                              <v-list-item-avatar>
                                <img :src="data.item.imagen_usuario">
                              </v-list-item-avatar>
                              <v-list-item-content>
                                <v-list-item-title v-html="data.item.nombres"></v-list-item-title>
                                <v-list-item-subtitle v-html="data.item.grupo"></v-list-item-subtitle>
                              </v-list-item-content>
                            </template>
                          </template>
                        </v-autocomplete>
                        <v-select :items="etapas" v-model="etapamovimiento" label="etapas" outlined v-if="movimientos.length > 0"></v-select>
                        </v-card-text>
                    </v-card>
                    <br>
                    <v-btn absolute dark bottom right color="success" @click="procesarEtapas" v-if="movimientos.length > 0 && etapamovimiento">
                      Procesar
                    </v-btn>  
                </v-tab-item>

            </v-tabs>


    </v-card>

    <v-dialog v-model="dialog" max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            
            <v-row align="center"> 
              
              <v-col cols="12">
                <v-text-field v-model="editedItem.nombre" label="Ingrese un nombre especifico*" maxlength="40" required outlined></v-text-field>
                <v-row>
                  <v-col cols="6">
                    <v-btn color="blue darken-1" text v-if="editedIndex == -1" @click="diccionario = true">Importar desde Biblioteca</v-btn>
                  </v-col>
                  <v-col cols="6" style="text-align: right;">
                    <v-btn color="green darken-1" text v-if="editedIndex == -1" @click="diccionariodef = true">Explorar otras Bibliotecas</v-btn>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12">
                  <v-textarea v-model="editedItem.descripcion" outlined label="Ingrese la Descripcion*" rows="2"></v-textarea>
              </v-col>

              <v-col cols="12">
                  <v-textarea v-model="editedItem.casoexito" outlined label="Criterio de Exito" rows="2"></v-textarea>
              </v-col>

              <v-col cols="12">
                  <v-textarea v-model="editedItem.resultados" outlined label="Resultados" rows="2"></v-textarea>
              </v-col>

              <v-col cols="12">
                  <v-textarea v-model="editedItem.categoria" outlined label="Categoria" rows="2"></v-textarea>
              </v-col>

                <v-col cols="2">
                    <v-text-field type="number"  min="1" max="100" prefix="%" v-model="editedItem.peso" label="Peso" required outlined value="0"></v-text-field>
                </v-col>

              <v-col cols="5">
                <v-text-field v-model="editedItem.fecinicio" label="Fecha Inicio" readonly required outlined @click="fechas('inicio')" ></v-text-field>
              </v-col>

              <v-col cols="5">
                <v-text-field v-model="editedItem.fecfin" label="Fecha Fin" readonly required outlined @click="fechas('fin')"></v-text-field>
              </v-col>

              <v-col cols="12">
                    <v-autocomplete v-model="asignados" :items="colaboradores2" 
                          outlined label="Colaboradores" item-text="nombres" item-value="iden" multiple>
                          <template v-slot:selection="data">
                            <v-chip
                              v-bind="data.attrs"
                              :input-value="data.selected"
                              close
                              @click="data.select"
                              @click:close="removeGrup(data.item)"
                            >
                              <v-avatar left>
                                <v-img :src="data.item.imagen_usuario"></v-img>
                              </v-avatar>
                              {{ data.item.nombres }}
                            </v-chip>
                          </template>
                          <template v-slot:item="data">
                            <template v-if="typeof data.item !== 'object'">
                              <v-list-item-content v-text="data.item"></v-list-item-content>
                            </template>
                            <template v-else>
                              <v-list-item-avatar>
                                <img :src="data.item.imagen_usuario">
                              </v-list-item-avatar>
                              <v-list-item-content>
                                <v-list-item-title v-html="data.item.nombres"></v-list-item-title>
                                <v-list-item-subtitle v-html="data.item.grupo"></v-list-item-subtitle>
                              </v-list-item-content>
                            </template>
                          </template>
                        </v-autocomplete>
                <!-- <v-select :items="listaCombinada" v-model="editedItem.asignado" label="Asignacion A:" outlined></v-select> -->
              </v-col>

            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="presave">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

      <v-dialog ref="dialog" v-model="modal" persistent width="290px">
        <v-date-picker v-model="date" scrollable v-if="dialogofType=='inicio'" :max="datosEv.fechafin" :min="datosEv.fechainicio" @input="fechasave(dialogofType)">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
          <v-btn text color="primary" @click="fechasave(dialogofType)">OK</v-btn>
        </v-date-picker>

        <v-date-picker v-model="date" scrollable v-if="dialogofType=='fin'" :max="datosEv.fechafin" :min="datosEv.fechainicio" @input="fechasave(dialogofType)">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
          <v-btn text color="primary" @click="fechasave(dialogofType)">OK</v-btn>
        </v-date-picker>
      </v-dialog>

      <v-dialog v-model="dialog2" max-width="500px">
        <v-card>
          <v-card-title>
            Asignacion Masiva
          </v-card-title>
          <v-card-text>

            <br>
            <v-select :items="listaCombinada" v-model="afectados" label="Seleccione algun criterio" outlined></v-select>
            
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" text @click="dialog2 = false" >
              Cancelar
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark @click="asignar">
              Asignar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="diccionario" max-width="600px">
        <v-card>
          <v-toolbar color="primary" dark>
              <v-toolbar-title aling="center">Diccionario de {{this.apiPathUse == 'competenciainstitucion' ? 'Competencias' : 'Objetivos'}}</v-toolbar-title>
            </v-toolbar>
            <v-card flat>

              <v-card-text>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Buscar"
                  single-line
                  hide-details
                ></v-text-field>
                <v-data-table
                  :headers="headersdic"
                  :items="(this.apiPathUse == 'competenciainstitucion') ? comdic : objdic"
                  :items-per-page="5"
                  class="elevation-1"
                  :search="search"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-icon small @click="copiar(item)">mdi-forward</v-icon>
                    
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <v-card-actions>
            
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="diccionario = false">Cancelar</v-btn>
            
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="diccionariodef" max-width="600px">
        <v-card>
          <v-toolbar color="primary" dark>
              <v-toolbar-title aling="center">Biblioteca de {{this.apiPathUse == 'competenciainstitucion' ? 'Competencias' : 'Objetivos'}}</v-toolbar-title>
            </v-toolbar>
            <v-card flat>

              <v-card-text>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Buscar"
                  single-line
                  hide-details
                ></v-text-field>
                <v-data-table
                  :headers="headersdic"
                  :items="(this.apiPathUse == 'competenciainstitucion') ? comdef : objdef"
                  :items-per-page="5"
                  class="elevation-1"
                  :search="search"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-icon small @click="copiar(item)">mdi-forward</v-icon>
                    
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <v-card-actions>
            
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="diccionariodef = false">Cancelar</v-btn>
            
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import api from "../conf/ruta-base";
import store from "../store";
import UserProfile from '../data';
import moment from "moment";
import swal from 'sweetalert';
import avisoinicio from '../components/avisoInicio';
import avisofin from '../components/avisoFin';
moment.locale('es');
export default {
  name: "evaluacionadm",
  components:{avisoinicio,avisofin},
  data: () => ({
    apiPath: "evaluacion", apiPathObj: "objetivoinstitucion", apiPathCom: "competenciainstitucion", apiPathUse: '',
    dialog: false, dialog2: false, modal: false, dialogoType: "", dialogofType: '', diccionario: false, diccionariodef: false,
    sumCom: 0, sumObj: 0, user: UserProfile.getUserData(), numPasos: 0, search: '',
    date: new Date().toISOString().substr(0, 10), afectados: null,
    status: [{text:'No Iniciado',value:0},{text:'Iniciado',value:1},{text:'Detenido',value:2},{text:'Finalizado',value:3}],
    headers: [
      { text: "Nombre", align: "start", sortable: true, value: "nombre" },
      { text: "Descripcion", value: "descripcion" },
      { text: "Peso", value: "peso" },
      { text: "Fecha Inicio", value: "fecinicio" },
      { text: "Fecha Fin", value: "fecfin" },
      { text: "Asignado", value: "asignado" },
      { text: "Actions", value: "actions", sortable: false }
    ],
    headersdic: [
      { text: "Competencia", align: "start", sortable: true, value: "nombre" },
      { text: "Descripcion", sortable: true, value: "descripcion" },
      { text: "Actions", value: "actions", sortable: false }
    ],
    editedIndex: -1,
    editedItem: {
      id: '', nombre: '', descripcion: '', peso: '', fechainicia: '', fechafin: '', status: 1, fecinicio: '', fecfin: '', dstatus: '', asignado: '', categoria: '',
    },
    defaultItem: {
      id: '', nombre: '', descripcion: '', peso: '', fechainicia: '', fechafin: '', status: 1, fecinicio: '', fecfin: '', dstatus: '', asignado: '', categoria: '',
    },
    datos: [], datosEv: [], datosCom: [], datosObj: [], datosNiv: [], comdic:[], objdic:[], comdef:[], objdef:[], avisos:[], movimientos: [], colaboradores:[], etapas:[],
    evdesc: '', evfecini: '', evfecfin: '', evfinaliza: '', colaboradoresTmp: [], colaboradoresOrg: [], colaboradores2: [], asignados: [],
    evcompetencias: '', evobjetivos: '', vcompetencias: '', vobjetivos: '',
    evpaso: 0, etapamovimiento: null,
    selec: '',
    listaCombinada:[
      {text:'Todos los Colaboradores con supervisor',value:'Todos'},
    ],
  }),

  created() {
    let todos = {
        nombres: 'Todos los usuarios con supervisor establecido',
        grupo: 'Todos',
        imagen_usuario: api.api + 'uploads/avatar-grup.jpg',
        iden: 'Todos'
    }
    this.colaboradores2.push(todos,{divider: true})
    this.colaboradoresOrg.push(todos,{divider: true})
  },

  mounted() {
    //Consultamos la Evaluacion General
    let id = this.$route.params.id
    axios
      .get(api.api + this.apiPath + '/id/' + id)
      .then(r => {
            this.evfecini = moment(r.data.fechainicio).format('L');
            this.evfecfin = moment(r.data.fechafin).format('L');
            this.evcompetencias = r.data.bcompetencias;
            this.evobjetivos = r.data.bobjetivos;
            this.vcompetencias = r.data.vcompetencias;
            this.vobjetivos = r.data.vobjetivos;
            this.apiPathUse = (r.data.vcompetencias > 0) ? this.apiPathCom : this.apiPathObj
            //this.evfinaliza = moment().endOf(r.data.fechafin).fromNow();
            this.evdesc = r.data.descripcion;
            //this.evpaso = parseInt(r.data.paso)
            this.datosEv=r.data
      })
      .catch(error => {
        console.log(error);
      });

    //Consultamos los avisos
    axios
      .get(api.api + 'aviso/'+id)
      .then(r => {
        for(let i = 0; i < r.data.length; i++) {
          if(r.data[i].mensaje_inicio.length > 0){
            r.data[i].pred_inicio = true
          }else{
            r.data[i].pred_inicio = false
          }
          if(r.data[i].mensaje_fin.length > 0){
            r.data[i].pred_fin = true
          }else{
            r.data[i].pred_fin = false
          }
          if(r.data[i].tipoaviso=='avi_generales'){
            r.data[i].aviso_inicio = 'Inicio Evaluacion General'
            r.data[i].aviso_fin = 'Fin Evaluacion General'
          }
          if(r.data[i].tipoaviso=='avi_col'){
            r.data[i].aviso_inicio = 'Inicion Fijación de Objetivos Colaboradores'
            r.data[i].aviso_fin = 'Fin Fijación de Objetivos Colaboradores'
          }
          if(r.data[i].tipoaviso=='avi_sup'){
            r.data[i].aviso_inicio = 'Inicio Revisión/Aprobación Supervisor'
            r.data[i].aviso_fin = 'Fin Revisión/Aprobación Supervisor'
          }
          if(r.data[i].tipoaviso=='avi_med_col'){
            r.data[i].aviso_inicio = 'Inicio Evaluacion Medio Año del Colaborador'
            r.data[i].aviso_fin = 'Fin Evaluacion Medio Año del Colaborador'
          }
          if(r.data[i].tipoaviso=='avi_med_supmat'){
            r.data[i].aviso_inicio = 'Inicio Evaluacion Medio Año del Supervisor Matricial'
            r.data[i].aviso_fin = 'Fin Evaluacion Medio Año del Supervisor Matricial'
          }          
          if(r.data[i].tipoaviso=='avi_med_sup'){
            r.data[i].aviso_inicio = 'Inicio Evaluacion Medio Año del Supervisor'
            r.data[i].aviso_fin = 'Fin Evaluacion Medio Año del Supervisor'
          }
          if(r.data[i].tipoaviso=='avi_fin_col'){
            r.data[i].aviso_inicio = 'Inicio Evaluacion Final del Colaborador'
            r.data[i].aviso_fin = 'Fin Evaluacion Final del Colaborador'
          }
          if(r.data[i].tipoaviso=='avi_fin_sup'){
            r.data[i].aviso_inicio = 'Inicio Evaluacion Final del Supervisor'
            r.data[i].aviso_fin = ' Fin Evaluacion Final del Supervisor'
          }
          if(r.data[i].tipoaviso=='avi_fin_supmat'){
            r.data[i].aviso_inicio = 'Inicio Evaluacion Final del Supervisor Matricial'
            r.data[i].aviso_fin = ' Fin Evaluacion Final del Supervisor Matricial'
          }
          if(r.data[i].tipoaviso=='avi_cal'){
            r.data[i].aviso_inicio = 'Inicio Proceso de Calibración'
            r.data[i].aviso_fin = 'Fin Proceso de Calibración'
          }
          if(r.data[i].tipoaviso=='avi_ret'){
            r.data[i].aviso_inicio = 'Inicio Proceso de Retroalimentación'
            r.data[i].aviso_fin = 'Fin Proceso de Retroalimentación'
          }                    
          if(r.data[i].tipoaviso=='avi_fir_col'){
            r.data[i].aviso_inicio = 'Inicio Proceso de Firma del Colaborador'
            r.data[i].aviso_fin = 'Fin Proceso de Firma del Colaborador'
          }
          if(r.data[i].tipoaviso=='avi_fir_sup'){
            r.data[i].aviso_inicio = 'Inicio Proceso de Firma del Supervisor'
            r.data[i].aviso_fin = 'Fin Proceso de Firma del Supervisor'
          }
          this.avisos.push(r.data[i])
        }
      })
      .catch(error => {
        console.log(error);
      });

    //Consultamos los objetivos asociados a esa Evaluacion
    axios
      .get(api.api + this.apiPathObj+'/evaluacion/'+id)
      .then(r => {
        let i = 0;
        for (i = 0; i < r.data.length; i++) {
            r.data[i].fecinicio = moment(r.data[i].fechainicia).format('L');
            r.data[i].fecfin = moment(r.data[i].fechafin).format('L');
            r.data[i].fechas = moment(r.data[i].fechainicia).format('L')+" "+moment(r.data[i].fechafin).format('L');
            r.data[i].dstatus = r.data[i].asignado//(r.data[i].status==0) ? 'No Activo':'Activo';
            this.sumObj += parseInt(r.data[i].peso)
          this.datosObj.push(r.data[i]);
        }
      })
      .catch(error => {
        console.log(error);
      });

    //Consultamos las competencias asociadas a esa Evaluacion
    axios
      .get(api.api + this.apiPathCom+'/evaluacion/'+id)
      .then(r => {
        for(let i = 0; i < r.data.length; i++) {
            r.data[i].fecinicio = moment(r.data[i].fechainicia).format('L');
            if(r.data[i].fechamedio != '0000-00-00 00:00:00' & r.data[i].fechamedio != ''){
                r.data[i].fecmedio = moment(r.data[i].fechamedio).format('L');
            }
            r.data[i].fecfin = moment(r.data[i].fechafin).format('L');
            r.data[i].fechas = moment(r.data[i].fechainicia).format('L')+" "+moment(r.data[i].fechafin).format('L');
            r.data[i].dstatus = r.data[i].asignado//(r.data[i].status==0) ? 'Inactiva':'Activa';
            this.sumCom += parseInt(r.data[i].peso)
          this.datosCom.push(r.data[i]);
        }
      })
      .catch(error => {
        console.log(error);
      });

    //Consultamos los diferentes departamentos que maneja la institucion con respecto a los empleados
    axios
      .get(api.api + this.apiPath + '/nivelev/'+id)
      .then(r => {
        this.datosNiv = r.data
      })
      .catch(error => {
        console.log(error);
      });


    //Consultamos el diccionario de las competencias this.apiPathUse == 'competenciainstitucion'
    axios
      .get(api.api + 'comdic/dic')
      .then(r => {
        for (let i = 0; i < r.data.length; i++) {
          if(r.data[i].institucion>0){
            this.comdic.push(r.data[i])
          }else{
            this.comdef.push(r.data[i])
          }
        }
      })
      .catch(error => {
        console.log(error);
      });  

    //Consultamos el diccionario de las competencias this.apiPathUse == 'competenciainstitucion'
    axios
      .get(api.api + 'objdic/dic')
      .then(r => {
        for (let i = 0; i < r.data.length; i++) {
          if(r.data[i].institucion>0){
            this.objdic.push(r.data[i])
          }else{
            this.objdef.push(r.data[i])
          }
        }
      })
      .catch(error => {
        console.log(error);
      }); 

    //Consultamos los diferentes grupos que maneja la institucion con respecto a los empleados
    axios
      .get(api.api + 'empleado/grupos')
      .then(r => {
        this.colaboradores2.push({header: 'Grupos'})
        this.colaboradoresOrg.push({header: 'Grupos'})
        for (let i = 0; i < r.data.length; i++) {
          if(r.data[i].grupo != 'default'){
            this.listaCombinada.push({
              text:'Grupo: '+r.data[i].grupo,
              value:r.data[i].grupo
            })
            let gru = {
              id: r.data[i].grupo,
              nombres: 'Grupo: ' + r.data[i].grupo,
              grupo: r.data[i].grupo,
              imagen_usuario: api.api + 'uploads/avatar-grup.jpg',
              iden: 'gru-'+r.data[i].grupo
            }
          this.colaboradores2.push(gru)
          this.colaboradoresOrg.push(gru)
          }
        }
      })
      .catch(error => {
        console.log(error);
      });

    //Consultamos Los empleados
    axios
      .get(api.api + 'empleado/ev/'+id)
      .then(r => {
        this.colaboradores2.push({divider: true},{header: 'Colaboradores'})
        this.colaboradoresOrg.push({divider: true},{header: 'Colaboradores'})
        for (let i = 0; i < r.data.length; i++) {
          if(r.data[i].level=='usr'){
            //for(let y = 0; y < r.data[i].evcol.length; y++){
              //if(r.data[i].evcol[y].idevaluacion == id){
                let col = {
                  id: r.data[i].id,
                  nombres: r.data[i].nombres + ' ' + r.data[i].apellidos,
                  grupo: r.data[i].grupo,
                  imagen_usuario: r.data[i].imagen_usuario,
                  iden: 'col-'+r.data[i].id+'-'+r.data[i].grupo
                }
                this.colaboradores.push(col)
                this.colaboradores2.push(col)
                this.colaboradoresOrg.push(col)
                //break
              //}
            //}
          }
        }
      })
      .catch(error => {
        console.log(error);
      }); 

    //Consultamos las Etapas
    axios
      .get(api.api + 'evaluacion/etapas/'+id)
      .then(r => {
        for (let i = 0; i < r.data.length; i++) {
            let et = {
              value: r.data[i].etapa,
              text:  r.data[i].etapaname,
            }
            this.etapas.push(et)
        }
      })
      .catch(error => {
        console.log(error);
      });        
  },

  watch: {
      dialog(valor){
          if(!valor){
              this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
                });
          }
      },
      asignados(){
      this.colaboradoresTmp = []
      this.colaboradores2 = []
        for(let i = 0; i < this.asignados.length; i++){
          if(this.asignados[i]=='Todos'){
            this.asignados = 'Todos'
          }
          let tipo = this.asignados[i].split('-')
          if(tipo[0]=='gru'){
            for(let y = 0; y < this.asignados.length; y++){
              let tipo2 = this.asignados[y].split('-')
              if(tipo2.length>2){
                if(tipo2[2]==tipo[1]){
                  let index = this.asignados.indexOf(this.asignados[y])
                  if(index >= 0){
                    this.asignados.splice(index, 1)
                  }
                }
              }
            }
            for(let y = 0; y < this.colaboradoresOrg.length; y++){
              if(this.colaboradoresOrg[y].iden){
                let tipoTem = this.colaboradoresOrg[y].iden.split('-')
                if(tipoTem.length>2){
                  if(tipoTem[2]==tipo[1]){
                    this.colaboradoresTmp.push(this.colaboradoresOrg[y])
                  }
                }
              }
            }
          }
        }
        if(this.asignados!='Todos'){
          for(let x = 0; x < this.colaboradoresOrg.length; x++){
            let bandera = true
            for(let y = 0; y < this.colaboradoresTmp.length; y++){
              if(this.colaboradoresOrg[x].iden == this.colaboradoresTmp[y].iden){
                bandera = false
                break
              }
            }
            if(bandera){
              this.colaboradores2.push(this.colaboradoresOrg[x])
            }
          }
        }else{
            let todos = {
              nombres: 'Todos los usuarios con supervisor establecido',
              grupo: 'Todos',
              imagen_usuario: api.api + 'uploads/avatar-grup.jpg',
              iden: 'Todos'
            }
          this.colaboradores2.push(todos)
          this.asignados = 'Todos'
        }
      },
      
      movimientos(){
      this.colaboradoresTmp = []
      this.colaboradores2 = []
        for(let i = 0; i < this.movimientos.length; i++){
          if(this.movimientos[i]=='Todos'){
            this.movimientos = 'Todos'
          }
          let tipo = this.movimientos[i].split('-')
          if(tipo[0]=='gru'){
            for(let y = 0; y < this.movimientos.length; y++){
              let tipo2 = this.movimientos[y].split('-')
              if(tipo2.length>2){
                if(tipo2[2]==tipo[1]){
                  let index = this.movimientos.indexOf(this.movimientos[y])
                  if(index >= 0){
                    this.movimientos.splice(index, 1)
                  }
                }
              }
            }
            for(let y = 0; y < this.colaboradoresOrg.length; y++){
              if(this.colaboradoresOrg[y].iden){
                let tipoTem = this.colaboradoresOrg[y].iden.split('-')
                if(tipoTem.length>2){
                  if(tipoTem[2]==tipo[1]){
                    this.colaboradoresTmp.push(this.colaboradoresOrg[y])
                  }
                }
              }
            }
          }
        }
        if(this.movimientos!='Todos'){
          for(let x = 0; x < this.colaboradoresOrg.length; x++){
            let bandera = true
            for(let y = 0; y < this.colaboradoresTmp.length; y++){
              if(this.colaboradoresOrg[x].iden == this.colaboradoresTmp[y].iden){
                bandera = false
                break
              }
            }
            if(bandera){
              this.colaboradores2.push(this.colaboradoresOrg[x])
            }
          }
        }else{
            let todos = {
              nombres: 'Todos los usuarios con supervisor establecido',
              grupo: 'Todos',
              imagen_usuario: api.api + 'uploads/avatar-grup.jpg',
              iden: 'Todos'
            }
          this.colaboradores2.push(todos)
          this.movimientos = 'Todos'
        }
      }
  },
  computed: {
    formTitle() {
      let tit = (this.apiPathUse == 'competenciainstitucion') ? 'Competencia Institucional' : 'Objetivo Institucional'
      return this.editedIndex === -1 ? tit : "Modificar "+tit
    }
  },
  methods: {

    editItem(item) {
      this.editedIndex = (this.apiPathUse == 'competenciainstitucion') ? this.datosCom.indexOf(item) : this.datosObj.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    enviarPaso(level){
        axios
        .put(api.api + this.apiPath+'/paso/'+level, {id:this.$route.params.id})
        .then(res => {
            this.evpaso = res.data.paso;
            this.toast(res.data.c, res.data.mensaje);
        })
        .catch(error => {
            console.log(error);
        });
    },

    close() {
      this.asignados = []
      this.colaboradores2 = this.colaboradoresOrg
      this.colaboradoresTmp = null
      this.dialog = false
      this.dialog2 = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      });
    },

    presave(){
      this.editedItem.asignado = this.asignados
      let bandera = true
      let err = ''
        if(bandera && this.editedItem.descripcion.length == 0){
          bandera = false
          err = 'Debe ingresar un nombre descriptivo de la Evaluacion.'
        }

        if(bandera && (this.editedItem.fecinicio.length == 0 || this.editedItem.fecfin.length == 0)){
          bandera = false
          err = 'Debe especificar las fechas de Inicio y Fin del Proceso'
        }
  
        if(bandera && (this.editedItem.casoexito.length == 0 || this.editedItem.resultados.length == 0)){
          bandera = false
          err = 'Faltan datos relevantes'
        }

        if(bandera && (this.editedItem.nombre.length == 0 || this.editedItem.peso.length == 0)){
          bandera = false
          err = 'Verifique el nombre o el peso'
        }

        if(bandera && this.editedItem.asignado.length == 0){
          bandera = false
          err = 'Debe seleccionar el grupo a asignar'
        }
      if(bandera){
        this.save()
      }else{
        swal('',err,'error');
      }
      
    },

    save() {
      this.colaboradores2 = this.colaboradoresOrg
      this.colaboradoresTmp = null
      if (this.editedIndex > -1) {
        if(this.apiPathUse == 'competenciainstitucion'){
          let sumCom = parseInt(this.sumCom) - parseInt(this.datosCom[this.editedIndex].peso) + parseInt(this.editedItem.peso)
            Object.assign(this.datosCom[this.editedIndex], this.editedItem);
            this.sumCom = parseInt(sumCom)
        }else{
          let sumObj = parseInt(this.sumObj) - parseInt(this.datosObj[this.editedIndex].peso) + parseInt(this.editedItem.peso)
            Object.assign(this.datosObj[this.editedIndex], this.editedItem);
            this.sumObj = parseInt(sumObj)
        }  
        axios
          .put(api.api + this.apiPathUse, this.editedItem)
          .then(res => {
            this.toast(res.data.c, res.data.mensaje);
          })
          .catch(error => {
            console.log(error);
          });
      } else {
          if(this.apiPathUse != 'competenciainstitucion'){
            let sumObj = parseInt(this.sumObj) + parseInt(this.editedItem.peso)
          }else{
            let sumCom = parseInt(this.sumCom) + parseInt(this.editedItem.peso)
          }
        this.editedItem.evaluacion = this.$route.params.id;
        axios
          .post(api.api + this.apiPathUse, this.editedItem)
          .then(r => {
            r.data.fecinicio = moment(r.data.fechainicia).format('L');
            r.data.fecfin = moment(r.data.fechafin).format('L');
            r.data.dstatus = (r.data.status==0) ? 'No Iniciado':'Iniciado';
            if(this.apiPathUse == 'competenciainstitucion'){
                this.sumCom += parseInt(r.data.peso)
                this.datosCom.push(r.data);
            }else{
                this.sumObj += parseInt(r.data.peso)
                this.datosObj.push(r.data);
            }
            this.toast(r.data.c, r.data.mensaje);
          })
          .catch(error => {
            console.log(error);
          });
      }
      this.close();
    },
    
    deleteItem(item) {
      const index = (this.apiPathUse == 'competenciainstitucion') ? this.datosCom.indexOf(item) : this.datosObj.indexOf(item);
      swal({text: "¿Seguro que desea eliminar?",icon: "warning", buttons: ["Cancelar", "Ok"],})
      .then(ok => {   
        if(ok){
          axios.delete(api.api + this.apiPathUse, {data: item})
          .then(res => {
            if(res.data.c=='success'){
                if(this.apiPathUse == 'competenciainstitucion'){
                    this.sumCom -= parseInt(item.peso)
                    this.datosCom.splice(index, 1)
                }else{
                    this.sumObj -= parseInt(item.peso)
                    this.datosObj.splice(index, 1)
                }
            }
            this.toast(res.data.c, res.data.mensaje);
          })
          .catch(error => {
            console.log(error);
          });
        }
      })
    },

    toast(color, text) {
      var toast = { color, text };
      store.commit("TOAST", toast);
    },

    fechas(evento){
        this.dialogofType = evento;
        this.modal = true;
    },

    fechasave(evento){
        let [year, month, day] = this.date.split('-')
        let date = day.padStart(2, '0') + '/' + month.padStart(2, '0') + '/' + year;
        if(evento=='inicio'){
          this.editedItem.fecinicio = date;
          this.editedItem.fechainicia = this.date;
        }else if(evento=='medio'){
          this.editedItem.fecmedio = date;        
          this.editedItem.fechamedio = this.date;
        }else if(evento=='fin'){
            this.editedItem.fecfin = date;
            this.editedItem.fechafin = this.date;
        }
        this.dialogofType = '';
        this.modal = false;
        this.date = new Date().toISOString().substr(0, 10);
    },

    rep(tipo){
        this.apiPathUse = (tipo=='com') ? this.apiPathCom : this.apiPathObj
    },

    asignacion(item) {
      this.editedIndex = (this.apiPathUse == 'competenciainstitucion') ? this.datosCom.indexOf(item) : this.datosObj.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog2 = true;
    },

    asignar(){
      let editedIndex = this.editedIndex
      if(this.editedItem.id > 0 & this.afectados != null & this.afectados != ''){
        let opcion = this.afectados.split('-')
        let params = {
          ref: this.editedItem.id,
          tipo: opcion[0],
          datos: opcion[1]
        }
        axios
          .post(api.api + this.apiPathUse+'/asignar', params)
          .then(r => {
            if(this.apiPathUse == 'competenciainstitucion'){
              this.datosCom[editedIndex].asignado = r.data.asignado
              this.datosCom[editedIndex].dstatus = r.data.asignado
            }else{
              this.datosObj[editedIndex].asignado = r.data.asignado
              this.datosObj[editedIndex].dstatus = r.data.asignado
            }
            this.close();
            this.afectados = null
            this.toast(r.data.c, r.data.mensaje);
          })
          .catch(error => {
            console.log(error);
          });
        }
    },

    saveNiveles(){
      axios
          .put(api.api + this.apiPath + '/nivelev/', this.datosNiv)
          .then(r => {ch
            this.toast(r.data.c, r.data.mensaje);
          })
          .catch(error => {
            console.log(error);
          });
    },

    copiar(item){
      this.editedItem.nombre = item.nombre
      this.editedItem.descripcion = item.descripcion
      this.editedItem.casoexito = item.casoexito
      this.editedItem.resultados = item.resultados
      this.editedItem.peso = item.peso
      this.diccionario = false
      this.diccionariodef = false
    },

    publicar(){
      let bandera = true
      if(this.sumObj > 0){
        for(let i = 0; i < this.datosObj.length; i++){
          if(this.datosObj[i].asignado == undefined || this.datosObj[i].asignado == ''){
            bandera = false
            break
          }
        }
      }
      if(this.sumCom > 0){
        for(let i = 0; i < this.datosCom.length; i++){
          if(this.datosCom[i].asignado == undefined || this.datosCom[i].asignado == ''){
            bandera = false
            break
          }
        }
      }
      if(bandera){
        axios
          .put(api.api + this.apiPath + '/publicar/' + this.$route.params.id)
          .then(r => {
                this.datosEv.estado=1
                this.toast(r.data.c, r.data.mensaje);
          })
          .catch(error => {
            console.log(error);
          });
      }else{
        swal('',`Hay competencias o objetivos sin asignar`,'error');
      }
    },
    
    remove(item) {
        const index = this.movimientos.indexOf(item.id)
        if(index >= 0) this.movimientos.splice(index, 1)
    },
    
    removeGrup(item) {
        if(item.iden == 'Todos'){
          this.asignados = []
        }else{
          const index = this.asignados.indexOf(item.iden)
          if(index >= 0) this.asignados.splice(index, 1)
        }
    },

    procesarEtapas() {
      this.colaboradores2 = this.colaboradoresOrg
      this.colaboradoresTmp = null
      let params={
        etapa: this.etapamovimiento,
        colaboradores: this.movimientos,
      }
        axios
          .put(api.api + this.apiPath + '/moveretapas/' + this.$route.params.id,params)
          .then(r =>{
            this.toast(r.data.c, r.data.mensaje);
            this.etapamovimiento = null
            this.movimientos = []
          })
    },    
  }
};
</script>